import React, { PureComponent } from 'react';
import styled from 'styled-components';

const Img = styled.img`
height: ${(props) => props.height || "auto"};
width: ${(props) => props.width || "100%"};
border-radius:${(props) => props.borderRadius || "0"};
max-width: 725px;
min-width: 390px;
`
const ImgOuter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${(props) => props.height || "100%"};
  width: ${(props) => props.width || "100%"};
  padding: ${(props) => props.padding || "15% 5%"};
  top: ${(props) => props.top || "0"};
  position: relative;
`;
class ImgHeightAtom extends PureComponent {
  render() {
    return (
      <ImgOuter width={this.props.width} padding={this.props.padding} top={this.props.top}>
        <Img src={this.props.src} borderRadius={this.props.borderRadius} width={this.props.width}></Img>
      </ImgOuter>
    );
  }
}

export default ImgHeightAtom